<button
	[id]="openable() ? 'openFilters' : null"
	(click)="handleClick()"
	class="flex gap-2 rounded-[var(--button-border-radius)] border border-ui-100 bg-ui-25 px-4 py-3.5 font-semibold leading-none hover:bg-ui-50 focus:bg-ui-100 disabled:cursor-not-allowed disabled:opacity-50"
	data-test-class="filter-button"
>
	@if (iconLeading()) {
		<svg-icon
			[src]="iconLeading()"
			class="pointer-events-none size-4 grow-0"
		/>
	}
	<span class="pointer-events-none">{{ label() }}</span>
	@if (indicator()) {
		<span
			class="pointer-events-none flex size-4 items-center justify-center rounded-full bg-primary-100 text-xs leading-none text-white"
		>
			{{ indicator() }}
		</span>
	}
	@if (openable()) {
		<svg-icon
			class="pointer-events-none size-4 grow-0"
			src="assets/icons/icon-chevron-down.svg"
		/>
	}
</button>

@if (openable()) {
	<vp-sheet
		#filterSheet
		[isLoading]="false"
		sheetAlignment="right"
		sheetWidth="third"
		triggerId="openFilters"
	>
		<vp-sheet-header>
			<span class="h2 text-xl font-bold">
				{{ 'compositions.filters.sheet.header' | translate }}
			</span>
		</vp-sheet-header>
		<vp-sheet-content>
			<ng-content></ng-content>
		</vp-sheet-content>
		<vp-sheet-footer>
			<button (click)="filterSheet.hide()" class="btn btn-primary w-full">
				{{
					'compositions.filters.sheet.footer'
						| translate: { amount: numberOfResults() }
				}}
			</button>
		</vp-sheet-footer>
	</vp-sheet>
}
